import { TradeRestriction } from "./tradeRestriction";
import { SecurityDetails } from "../../simulations/models/securityDetails";
import { FixedIncomeTypeNames } from "../../common/enums/AssetClassType";

// TODO: Look at Model for entire recommendation screen.

export class TradeRecommendation {
  public id: number;

  public quantity: number;
  public idealBuySell: number;
  public buySellQuantity: number;

  public price: number;
  public costPrice: number;
  public marketValueDisplayCurrency: number;
  public assetClassAllocation: number;
  public cModelPercentage: number;
  public cModelItem; // Only for save later ... Need to refactor request objects
  public targetCModelAllocation: number;

  public targetMarketValue: number;
  public targetAssetClassAllocation: number;
  public targetModelAllocation: number;
  public hasActiveTradeSet: boolean;

  public security: SecurityDetails;
  public restriction?: TradeRestriction;
  public sellAllowed: boolean;

  public get targetQuantity(): number {
    return this.quantity + this.buySellQuantity;
  }

  public get cModelDelta() {
    return this.assetClassAllocation - this.cModelPercentage;
  }

  public get targetAssetCModelDelta() {
    return this.targetAssetClassAllocation - this.cModelPercentage;
  }

  public get targetCModelDelta() {
    return this.targetCModelAllocation - this.cModelPercentage;
  }

  public get totalPrice() {
    if (
      this.security.fixedIncomeType &&
      this.security.fixedIncomeType.name == FixedIncomeTypeNames.BOND
    ) {
      return (-1 * this.buySellQuantity * this.price) / 100;
    }
    return -1 * this.buySellQuantity * this.price;
  }

  public getPercentageOfPortfolio(total: number) {
    return +((this.marketValueDisplayCurrency * 100) / total).toFixed(2);
  }

  public getTargetPercentageOfPortfolio(targetTotal: number) {
    return +((this.targetMarketValue * 100) / targetTotal).toFixed(2);
  }

  public recommendationIsValid(targetTotal, assetClasses): boolean {
    if (!this.restriction) {
      return true;
    }
    if (!this.restriction.enabled) {
      return true;
    }
    if (!this.restriction.percentageOfPortfolio) {
      return true;
    }

    if (this.restriction.assetClass) {
      let assetTotal = 0;
      let allTotal = 0;
      assetClasses.forEach((assetClass) => {
        if (assetClass.name == this.restriction.assetClass.name) {
          assetTotal = assetClass.total;
        }
        allTotal += assetClass.total;
      });
      let assetPercentage = ((assetTotal / allTotal) * 100).toFixed(2);
      return (
        assetPercentage < this.restriction.maxPortfolio &&
        assetPercentage > this.restriction.minPortfolio
      );
    } else {
      const targetPercentage = this.getTargetPercentageOfPortfolio(targetTotal);
      return (
        this.restriction.maxPortfolio >= targetPercentage &&
        this.restriction.minPortfolio <= targetPercentage
      );
    }
  }

  constructor(tradeDTO) {
    this.id = tradeDTO.id;

    this.price = tradeDTO.price || 0;
    this.costPrice = tradeDTO.costPrice || 0;

    this.cModelItem = tradeDTO.cModelItem;
    this.cModelPercentage = tradeDTO.cModelItem
      ? tradeDTO.cModelItem.modelPercentage
      : 0;

    this.quantity = tradeDTO.quantity || 0;
    this.idealBuySell = tradeDTO.idealBuySell || 0;
    this.buySellQuantity = tradeDTO.buySellQuantity || 0;

    this.assetClassAllocation = tradeDTO.assetClassAllocation || 0;
    this.targetAssetClassAllocation = tradeDTO.targetAssetClassAllocation || 0;
    this.targetCModelAllocation = 0;

    this.targetMarketValue = tradeDTO.targetMarketValue || 0;
    this.targetModelAllocation = tradeDTO.targetModelAllocation || 0;
    this.marketValueDisplayCurrency = tradeDTO.marketValueDisplayCurrency || 0;
    this.hasActiveTradeSet = tradeDTO.hasActiveTradeSet;

    this.security = tradeDTO.security;
    if (tradeDTO.restriction) {
      this.restriction = new TradeRestriction(tradeDTO.restriction);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/trading/models/tradeRecommendation.ts